import styled from 'styled-components';
import { BOX_SHADOW, DARKER, PRIMARY, SECONDARY } from '../../const/colors';
import { Link } from 'react-router-dom';

export const Span = styled.span`
	position: relative;
	z-index: 2;
	&.slick-prev:before, &.slick-next:before {
		font-size: 0;
		content: '';
		height: 0;
		width: 0;
	}
    &.slick-next {
        left: 80%;
        top: -17%;
    }
    &.slick-prev {
        left: 75%;
        top: -17%;
    }
	@media screen and (max-width: 768px) {
		&.slick-next {
			left: 54%;
    		top: 100%;
		}
		&.slick-prev {
			left: inherit;
			right: 63%;
			top: 100%;
		}
	}
`;
export const WitgetContainer = styled.div`
	padding-top:10px;
	padding-bottom:50px;
	padding-left:1.5rem;
	padding-right:1.5rem;
	& span.title{
		position:relative;
		font-size: 2.2rem;
		color: rgb(255, 255, 255);
		margin-bottom: 2rem;
		font-weight: 800;
		display: inline-block;
	}
	& span.title::after {
		content: "";
		height: 2px;
		background: ${PRIMARY};
		position: absolute;
		left: 0;
		right: 0;
		bottom: -6px;
		opacity: 0;
		transform-origin: left center;
		transition: all 0.25s cubic-bezier(0.25, 0.43, 0.45, 0.94) 0s;
		transform: scaleX(0);
	  }
	  &:hover {
		span.title:after {
		  transform: scaleX(1);
		  opacity: 1;
		}
	  }
	  @media screen and (max-width: 768px) {
		padding: 5px 0 0 0;
		& span.title{
			font-size: 1.5rem;
			margin-bottom: 1.5rem;
			display: block;
			
		}
	  }
`;
